import { entryCards, navLinks } from "@/mocks/home";

const terminals = [
  { label: "安卓客户端", href: "#collections" },
  { label: "iOS 客户端", href: "#collections" },
  { label: "电脑版网页", href: "#collections" },
  { label: "移动端轻量版", href: "#collections" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-50">
      <div className="h-1 w-full bg-primary-500" />
      <div className="px-4 py-12 md:px-6 md:py-14">
        <div className="mx-auto max-w-page">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-12 md:gap-10">
            <div className="md:col-span-5">
              <a href="#top" className="flex cursor-pointer items-center gap-2.5">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg font-bold text-background-50">
                  91
                </span>
                <span className="font-heading text-lg font-bold text-foreground-950">91下载</span>
              </a>
              <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
                一个集中式的 91下载平台入口汇总页，把官网入口、最新地址、可用网址与官方 app
                下载方式整理在同一处，方便随时查阅。
              </p>
            </div>

            <div className="md:col-span-3">
              <h3 className="font-label text-xs tracking-[0.2em] text-foreground-500">页面导航</h3>
              <ul className="mt-4 flex flex-col gap-3">
                {navLinks.map((link) => (
                  <li key={link.id}>
                    <a
                      href={`#${link.id}`}
                      className="cursor-pointer text-sm text-foreground-700 transition-colors hover:text-primary-600"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="md:col-span-4">
              <h3 className="font-label text-xs tracking-[0.2em] text-foreground-500">终端下载</h3>
              <ul className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
                {terminals.map((t) => (
                  <li key={t.label}>
                    <a
                      href={t.href}
                      className="cursor-pointer text-sm text-foreground-700 transition-colors hover:text-primary-600"
                    >
                      {t.label}
                    </a>
                  </li>
                ))}
              </ul>
              <div className="mt-5 flex flex-wrap gap-2">
                {entryCards.slice(0, 3).map((card) => (
                  <span
                    key={card.id}
                    className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-800"
                  >
                    {card.tag}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div className="mt-10 flex flex-col gap-3 border-t border-secondary-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-xs text-foreground-500">
              © 2026 91下载 · 入口汇总页，内容仅供入口指引参考
            </p>
            <p className="text-xs text-foreground-500">
              本页不含任何站内跳转，所有入口以顶部更新条时间为准
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}